import { styled } from "@mui/material";

export const DashboardContentStyled = styled("div")(
    ({ theme }) => `
    height: calc(100% - 76px);
`
);
